/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Vekn_DescInputs */



/**
* | output |
* | --- |
* | "Pull the member roster from VEKN. Runs automatically every 6 hours." |
*
* @param {Admin_Sync_Vekn_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_vekn_desc = /** @type {((inputs?: Admin_Sync_Vekn_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Vekn_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Récupère la liste des membres depuis VEKN. S'exécute automatiquement toutes les 6 heures.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descarga el registro de miembros desde VEKN. Se ejecuta automáticamente cada 6 horas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixa a lista de membros do VEKN. Executado automaticamente a cada 6 horas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica il registro dei membri da VEKN. Viene eseguita automaticamente ogni 6 ore.")
	return /** @type {LocalizedString} */ ("Pull the member roster from VEKN. Runs automatically every 6 hours.")
});